export default function ProgressScreen({
  progress = 0,
  message = "Uploading",
  mode = "percent", // "percent" | "count"
  count = 0,
  total = 0,
}) {
  const displayProgress = Math.min(Math.max(Math.round(progress), 0), 100);

  const heroText =
    mode === "count" ? (
      <>
        {count}
        <span className="mx-[0.05em] tracking-normal">/</span>
        {total}
      </>
    ) : (
      `${displayProgress}%`
  );

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-collectors-bg cursor-wait">
      <div className="relative flex flex-col items-center">
        <h1 className="font-display text-[15vw] md:text-[12vw] leading-none font-bold tracking-tighter text-collectors-black mix-blend-difference">
          {heroText}
        </h1>
        <p className="mt-4 font-mono text-sm md:text-base uppercase tracking-widest text-collectors-black text-center">
          {message}
        </p>
      </div>
      <div className="absolute bottom-12 left-0 w-full px-8 flex justify-between font-mono text-xs uppercase text-collectors-black">
        <span>Do Not Close This Tab</span>
        <span>Oditi Uploader v1.0</span>
      </div>
    </div>
  );
}